// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y4Eb","footer":"styles_footer__ermse","passCodeTooltip":"styles_passCodeTooltip__alUoc"};